import React from 'react';
import {Card, Col, Container, Form, Row} from 'react-bootstrap';
import '../layout/main.scss';
import '../home/home.scss';
import './collections.scss';
import sp_sog from '../../images/sp-sog.png';
import btcico from '../../images/btcico.png';
import ethico from '../../images/ethico.png';


function Collections() {
    return (
        <div className="App">
            <div className="collections">
                <Container>
                    <h3>Collections</h3>
                    <div className="collections_filters">Filters
                        <Form.Select aria-label="SelectChain">
                            <option>Blockchain</option>
                            <option value="1">Bitcoin/Counterparty</option>
                            <option value="2">Ethereum</option>
                            <option value="3">Klaytn</option>
                            <option value="4">Kusama</option>
                        </Form.Select>
                    </div>
                    <div className="mn-blocks home-collection">
                        <Row xs={1} sm={2} md={3} className="g-4">
                            {Array.from({ length: 20 }).map((_, idx) => (
                                <Col>
                                    <Card className="cards col_cards">
                                        <Card.Img variant="top" src={sp_sog} />
                                        <Card.Body>
                                            <h5>Spells of Genesis</h5>
                                            <hr/>
                                            <Card.Text>
                                                This is a longer card with supporting text below as a natural
                                                lead-in to additional content.
                                            </Card.Text>
                                            <Card.Text className="col_info">
                                                <span><img src={btcico} alt="BTC logo"/> <img src={ethico} alt="ETH logo"/></span>
                                                <span className="viewcol"><a href="">View collection</a></span>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </div>
                </Container>
            </div>
        </div>
    );
}

export default Collections;
